import React, { Component } from 'react';
import config from 'react-global-configuration';
import RequestApi from '../../Miscelania/RequestApi';

// Importação da tabela
import { BootstrapTable, TableHeaderColumn } from 'react-bootstrap-table';

import DatePicker from 'react-datepicker';
import Select from 'react-select';
import getLocale from '../../../i18n/getLocale';

class StaffAdministrativeTab extends Component {

  constructor(props) {
    super(props);

    this.state = {
      overlay: {
        message: '',
        type: '',
        status: 'closed',        
      },
      redirect_url: false,
      name: '',
      archive: '',
      expiration: '',
      dados: [],
      docs_types_list: [],
    };

    this.botaoDeletar = this.botaoDeletar.bind(this);
    this.adicionarArquivo = this.adicionarArquivo.bind(this);
    this.botaoDownloadArquivo = this.botaoDownloadArquivo.bind(this);
    this.deletar = this.deletar.bind(this);
    this.deletarLinha = this.deletarLinha.bind(this);

    this.locale = getLocale();
  }

  // Handlers
  handleSelectChange(name, event) {
    var change = {};
    if(event == null) {
      change[name] = null;
    } else {
      change[name] = event.value;
    }
    this.setState(change);
    this.setState({expiration: ''});
  }

  handleChange (name, event) {
    var change = {};
    change[name] = event.target.value;
    this.setState(change);
  } 

  handleChangeDatePicker (state, date) {
    var change = {};
    change[state] = date.format("DD/MM/YYYY");
    this.setState(change);
  }   

  // LM
  componentWillReceiveProps(newProps) {
    if(Array.isArray(newProps.adm_files)) {
      this.setState({dados: newProps.adm_files});
    }
    if(Array.isArray(newProps.docs_types_list)) {
      this.setState({docs_types_list: newProps.docs_types_list});
    }
  }

  adicionarArquivo(event) {
    event.preventDefault();
    var data = new FormData();
    var imagedata = document.querySelector(".input-archive-administrative").files[0];
    data.append("name", this.state.name);
    data.append("type", this.state.type);
    data.append("expiration", this.state.expiration);
    data.append("imagem", imagedata);
    data.append("staff_id", this.props.staff_id);
    var header = this.refs.request_api.header();
    var self = this;
    this.props.handleAlert('', '', 'open');
    Promise.resolve(header).then(function(value) {
      fetch(config.get('api') + '/funcionario/administrativo/arquivo', {
        method: 'POST',
        mode: 'cors',
        headers: value,
        body: data }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
          self.refs.request_api.validate(responseJson, 'alert');
          if (responseJson.status === 'success') {
            var dados_temp = self.state.dados;
            dados_temp.push(responseJson.data);
            self.setState({dados: dados_temp});
          }
          self.props.handleAlert(responseJson.message, responseJson.status, 'open');
        }).catch((error) => {
        console.error(error);
      });
    });   
  }

  botaoDeletar (cell, row, enumObject, index) {
    var variavel = (
      <button className="btn btn-sm btn-danger" value={cell} onClick={this.deletar}>
        <i className="fa fa-fw fa-trash"></i>
      </button>
    );

    return variavel;
  }

  deletar (event) {
    var staff_administrative_id = event.currentTarget.value;
    var confirm = window.confirm(this.locale.Tripulantes.EditarFuncionario.tabAdministrativo.deletar);
    if (confirm) {
      this.props.handleAlert('', '', 'open');
      var header = this.refs.request_api.header('application/json');
      var self = this;
      Promise.resolve(header).then(function(value) {
        fetch(config.get('api') + '/funcionario/administrativo/arquivo/' + staff_administrative_id, { method: 'DELETE', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
          self.refs.request_api.validate(responseJson, 'alert');
          self.props.handleAlert(responseJson.message, responseJson.status, 'open');
          if (responseJson.status === 'success') {
            self.deletarLinha(staff_administrative_id);
          }
        }).catch((error) => {
          console.error(error);
        });
      });      
    }
  }

  deletarLinha(staff_administrative_id) {
    var dados = this.state.dados;
    dados.map(function(dado, index){
      if (dado.id == staff_administrative_id) {
        dados.splice(index, 1);
      }
    });
    this.setState({dados: dados});
  }

  botaoDownloadArquivo (cell, row) {
    var dados = this.state.dados;
    var status = '';
    var arquivo = '';
    var nome = '';
    var url = '';
    dados.map(function(dado, index){
      if (dado.id == cell) {
        arquivo = dado.archive;
        nome = dado.name;
        url = dado.type;
      }
    });
    return (
      <a target="_blank" href={config.get('cdn') + '/files/administrative/' + url +'/' + arquivo}> {nome}</a>
    );
  }

  render() {
    return (
<div>
  <RequestApi ref={'request_api'} />
  <h3 className="page-title">{this.locale.Tripulantes.EditarFuncionario.tabAdministrativo.tituloAdicionarArquivos}</h3>
  <hr/>
    <form onSubmit={this.adicionarArquivo}> 
      <div className="row">
        <div className="col-md-6">
          <div className="form-group">
            <label>{this.locale.Tripulantes.EditarFuncionario.tabAdministrativo.formulario.TipoDeArquivo}:</label>
            <Select
              className="form-field-name"
              name="type"
              value={this.state.type}
              searchable={true}
              placeholder={''}
              onChange={this.handleSelectChange.bind(this, 'type')}
              options={this.state.docs_types_list}
            />    
          </div>
        </div>
        <div className="col-md-6">
          <div className="form-group">
            <label>{this.locale.Tripulantes.EditarFuncionario.tabAdministrativo.formulario.Arquivo}:</label>
            <input type="file" name="archive" className="form-control input-archive-administrative" placeholder={this.locale.Tripulantes.EditarFuncionario.tabAdministrativo.formulario.placeholder.Arquivo} value={this.state.archive} onChange={this.handleChange.bind(this, 'archive')} />
          </div>
        </div>
      </div>
      <div className="row">
        <div className="col-md-6">
          <div className="form-group">
            <label>{this.locale.Tripulantes.EditarFuncionario.tabAdministrativo.formulario.NomeDoArquivo}:</label>
            <input type="text" name="name" className="form-control" placeholder={this.locale.Tripulantes.EditarFuncionario.tabAdministrativo.formulario.placeholder.NomeDoArquivo} value={this.state.name} onChange={this.handleChange.bind(this, 'name')} />
          </div>
        </div>
        {this.state.type === 'passport' || this.state.type == 'american_visa' || this.state.type == "aso" ?
            <div className="col-md-6">
              <div className="form-group">
                <label>{this.locale.Tripulantes.EditarFuncionario.tabAdministrativo.formulario.DataDeValidade}:</label>
                <DatePicker value={this.state.expiration} onChange={this.handleChangeDatePicker.bind(this, 'expiration')} className="form-control" />
              </div>
            </div>
          : 
          ""
        }
      </div>
      <div className="row">
        <div className="col-md-12">
          <div className="form-group">
            <button type="submit" className="btn btn-primary btn-inline btn-block"><i className="fa fa-plus"></i> {this.locale.Tripulantes.EditarFuncionario.tabAdministrativo.formulario.botaoAdicionarArquivo}</button>
          </div>
        </div>
      </div>
    </form>
  <hr/>
  <BootstrapTable data={this.state.dados} pagination={true} striped={true} hover={true} exportCSV={true} options={{exportCSVText: this.locale.general.exportarTextoCSV, noDataText: this.locale.Tripulantes.EditarFuncionario.tabAdministrativo.tabela.semArquivos}} search={true} multiColumnSearch={true}  searchPlaceholder={this.locale.general.procurar}>

    <TableHeaderColumn isKey={true} dataFormat={this.botaoDownloadArquivo} dataField="id" dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: this.locale.general.procurar}}>{this.locale.Tripulantes.EditarFuncionario.tabAdministrativo.tabela.NomeDoArquivo}</TableHeaderColumn>

      <TableHeaderColumn dataField="type_str" dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: this.locale.general.procurar}}>{this.locale.Tripulantes.EditarFuncionario.tabAdministrativo.tabela.Tipo}</TableHeaderColumn>
      
      <TableHeaderColumn dataField="expiration_str" dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: this.locale.general.procurar}}>{this.locale.Tripulantes.EditarFuncionario.tabAdministrativo.tabela.Validade}</TableHeaderColumn>

    <TableHeaderColumn dataField="id" dataAlign="center" dataFormat={this.botaoDeletar} width='80'>{this.locale.Tripulantes.EditarFuncionario.tabAdministrativo.tabela.Acoes}</TableHeaderColumn>

  </BootstrapTable>
</div>
    );
  }
}

export default StaffAdministrativeTab;



// WEBPACK FOOTER //
// ./src/Components/Staffs/Elements/StaffAdministrativeTab.js